import {ApiClient} from '@hconnect/apiclient'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import type {MaterialStorage, DatamartSyncDetails} from '../types'

type Variables = {plantCode: string; storageId: number; dto: DatamartSyncDetails}

export const useAddStorageDatamartConnection = ({
  onError,
  onSuccess
}: {
  onError?: (error: AxiosError, variables: Variables) => void
  onSuccess?: (data: MaterialStorage, variables: Variables) => void
} = {}) =>
  useMutation<MaterialStorage, AxiosError, Variables>({
    mutationFn: async ({plantCode, storageId, dto}) => {
      const response = await ApiClient.axiosInstance.post<MaterialStorage>(
        `/plants/${plantCode}/material-storage/${storageId}/details/datamart`,
        dto
      )
      return response.data
    },
    onError,
    onSuccess
  })
